import React from "react";

// Brand-forward hero for Two Degrees, logo + brand colours + typography only, no photography.
// Deep indigo (ink) canvas washed with the logo's orange→amber gradient glow, badge mark at centre.
export function BrandHero({
  headline = "The right people are closer than you think.",
  sub = "Real peers. Real work. Access to the rooms worth being in.",
  className = "",
}) {
  return (
    <div
      data-testid="brand-hero"
      className={`relative h-full w-full overflow-hidden bg-ink ${className}`}
    >
      {/* warm brand glow, DUSK #EF5D41 → DAWN #EABE7B */}
      <div className="absolute -top-24 -left-24 w-[560px] h-[560px] rounded-full blur-[120px]"
        style={{ background: "radial-gradient(circle, rgba(239,93,65,0.55) 0%, rgba(234,190,123,0.20) 45%, transparent 70%)" }} />
      <div className="absolute bottom-[-140px] right-[-120px] w-[520px] h-[520px] rounded-full blur-[130px]"
        style={{ background: "radial-gradient(circle, rgba(142,193,193,0.28) 0%, transparent 70%)" }} />

      {/* grain + vignette */}
      <div className="absolute inset-0 bh-grain opacity-[0.06] mix-blend-overlay pointer-events-none" />
      <div className="absolute inset-0 pointer-events-none"
        style={{ background: "linear-gradient(to top, rgba(20,17,32,0.92) 0%, rgba(20,17,32,0.35) 45%, transparent 75%)" }} />

      {/* copy */}
      <div className="absolute bottom-12 left-12 right-12">
        <img src="/brand/wordmark-horizontal-light.png" alt="Two Degrees" className="w-48 h-auto mb-6 bh-rise" style={{ animationDelay: "0.05s" }} data-testid="brand-hero-wordmark" />
        <h2 className="font-serif text-white text-[2.6rem] leading-[1.08] max-w-md bh-rise" style={{ animationDelay: "0.15s" }}>
          {headline}
        </h2>
        <p className="text-white/70 mt-4 font-sans text-lg max-w-sm bh-rise" style={{ animationDelay: "0.28s" }}>
          {sub}
        </p>
      </div>
    </div>
  );
}

export default BrandHero;
